module.exports = __webpack_public_path__ + "484e2ae370fc3b769f7e9483bed6ae79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logotype.svg
// module id = 316
// module chunks = 0